import {
  onAuthStateChanged,
  sendPasswordResetEmail as firebaseSendPasswordResetEmail,
  signInWithEmailAndPassword
} from 'firebase/auth';
import { auth } from './index';
import { getUserAccess } from '../../api/user';
import { SPORTS } from '../../utils/constants';

export const resolveLandingSport = access => {
  const candidate = String(access?.defaultLandingSport || '').trim().toLowerCase();
  return SPORTS.includes(candidate) ? candidate : 'mlb';
};

const waitForAuthInitialization = (timeoutMs = 2500) => {
  if (auth.currentUser) {
    return Promise.resolve(auth.currentUser);
  }

  return new Promise(resolve => {
    let settled = false;

    const unsubscribe = onAuthStateChanged(auth, user => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      unsubscribe();
      resolve(user || null);
    });

    const timer = setTimeout(() => {
      if (settled) return;
      settled = true;
      unsubscribe();
      resolve(auth.currentUser || null);
    }, timeoutMs);
  });
};

export const getUserToken = async () => {
  let currentUser = auth.currentUser;
  if (!currentUser) {
    currentUser = await waitForAuthInitialization();
  }

  if (!currentUser) {
    return '';
  }

  return currentUser.getIdToken();
};

export const login = async (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const sendPasswordResetEmail = async email => {
  return firebaseSendPasswordResetEmail(auth, email);
};

export const getPostLoginDestination = async () => {
  const access = await getUserAccess();
  return access?.paid ? `/sports/${resolveLandingSport(access)}` : '/settings?tab=subscription-management';
};
